<template>
<BootstrapDialog title="添加绑定" ref="dialog" size="lg" @afterOpen="afterOpen()" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-10 col-sm-offset-1">
		            <h4 class="m-t-none m-b font-thin"><i class="fa fa-plus" aria-hidden="true"></i>添加直播与培训项目绑定关系</h4>
		            <form role="form" class="form-horizontal" style="margin-top: 20px" id="pldr_form">
		                <div class="form-group">
		                    <div class="col-sm-6">
		                        <div class="form-group">
		                            <label class="col-sm-3 control-label">培训项目</label>
		                            <div class="col-sm-9">
		                                <select name="xmIds" class="form-control" v-model="model.xmIds" v-validate="{required:true}" data-vv-as="培训项目">
		                                    <option value="">-请选择-</option>
		                                    <option :value="item.id" v-for="item in xmList" :key="item.id">{{item.mc}}</option>
		                                </select>
		                                <span class="error_validate_msg"><em>{{ errors.first('xmIds') }}</em></span>
		                            </div>
		                        </div>
		                    </div>
		                    <div class="col-sm-6">
		                        <button @click="save()" type="button" class="btn btn-success btn-sm " style="margin-right:3px"><i class="fa fa-check" aria-hidden="true"></i>保存</button>
		                    </div>
		                </div>
		            </form>
		            <div style="margin-top:2px">
		                <BootstrapTable style="font-size: 14px;"
		                                ref="table"
		                                v-once
		                                :columns="columns"
		                                :options="{
												classes:'table table-hover',
							        			undefinedText:'',
							                    showColumns: false,
							                    sidePagination:'server',
							                    pagination:false,
							                    pageNumber:1,
							                    pageSize:10,
							                    pageList:[10,50,100,500],
							                    paginationPreText:'上一页',
							                    paginationNextText:'下一页',
							                    showExtendedPagination:true,
							                    paginationLoop:false
							         }"
		                                @onPostBody="vueFormatterPostBody"
		                                @onPageChange="pageChange"
		                />
		            </div>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 直播-培训项目 直播的绑定关系
     */
    import tableMixin from '@/mixins/table.js';  //表格
    export default {
        mixins: [tableMixin],
        name:'ZbXmBind',
        data:function(){
            return {
                file:null,
                xmList:[],
                query:{
                    kczbid:''
                },
                model:{
                    kczbid:'',
                    xmIds:''
                },
                columns:[
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'xmbh',
                        title: '共享培训项目名称',
                        formatter: (value, row) => {
                            return row.xmbh+'-'+row.pxzt;
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let html="";
                            html += '<a @click="remove(row)">删除</a>';
                            return this.vueFormatter({
                                template: '<div class="operation_column">'
                                    +html
                                    +'</div>',
                                data: { row },
                                methods: {
                                    remove: this.remove
                                }
                            })
                        }
                    }
                ]
            }
        },
        methods:{
			reset:function(){
				this.file = null;
				this.xmList = [];
				this.query = {
				    kczbid:''
				};
				this.model = {
				    kczbid:'',
				    xmIds:''
				};
				this.$refs.table.load([]);
			},
			async open(params){
				this.query.kczbid = params.kczbid;
				this.model.kczbid = params.kczbid;
				let res =await this.$http.post('/htgl/biz/zypx/zb/hqpc');
				if(res.data){
				    this.xmList = res.data || [];
				}
				this.$refs.dialog.open();
			},
			afterOpen:function(){
				this.search();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            remove:function(row){
                this.$confirm('确定删除这条数据吗？',()=>{
                    this.$http.post('/htgl/biz/zypx/zb/removeKcXMRelation',{id:row.id}).then(res=>{
                        if(res.data){
                            this.$success('操作成功',()=>{
                                this.search();//刷新列表
                            });
                        }
                    });
                });
            },
            search:function(){
                this.$http.post('/htgl/biz/zypx/zb/queryRelationXm',this.query).then(res=>{
                    let data = res.data;
                    //table加载返回的数据
                    this.$refs.table.load(data);
                });
            },
            pageChange:function(pageNumber, pageSize){
                this.load(pageNumber, pageSize);
            },
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$http.post('/htgl/biz/zypx/zb/addZbXmRelation',this.model).then(res=>{
                            if(res.data){
                                this.$success('操作成功',()=>{
                                    this.search();
                                });
                            }
                        });
                    }
                });
            }
        }
    }
</script>
